import * as React from 'react';
export const IcFlightModeOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.71 8.57l4.56 2.92 4.61-4.61L4.7 5.81a1.5 1.5 0 00-.99 2.76zm0 7.47l2.5-2.5-1.43.13A1.5 1.5 0 003.71 16v.04zM20.5 3.5l-.13-.1.12.11a1 1 0 00-1.45 0L3.51 19A1.053 1.053 0 105 20.49l1.84-1.89.69 1.22a1.5 1.5 0 002.8-.6l.27-3 1.4-1.4 3.42 5.47a1.5 1.5 0 002.76-1L17 9.87l3.5-3.54a2 2 0 000-2.83z'
      fill='currentColor'
    />
  </svg>
);
